module.exports = __webpack_public_path__ + "img/10.2258e83d.png";